import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedSalon: null,
  salonBookData: null,
  salonAttributeFilters: {},
  salonCustomFilters: {},
};

const salonSlice = createSlice({
  name: "salon",
  initialState,
  reducers: {
    setSelectedSalon: (state, action) => {
      state.selectedSalon = {
        ...state.selectedSalon,
        ...action.payload,
      };
    },
    resetSelectedSalon: (state, action) => {
      state.selectedSalon = null;
    },
    setSalonBookedData: (state, action) => {
      state.salonBookData = {
        ...state.salonBookData,
        ...action.payload,
      };
    },
    resetBookingData: (state) => {
      state.salonBookData = null;
    },
    setSalonAttributeFilter: (state, action) => {
      state.salonAttributeFilters = {
        ...state.salonAttributeFilters,
        ...action.payload,
      };
    },
    removeSalonAttributeFilter: (state, action) => {
      state.salonAttributeFilters[action.payload.id] = null;
    },
    resetSalonAttributeFilter: (state, action) => {
      state.salonAttributeFilters = {};
    },
    setSalonCustomFilter: (state, action) => {
      state.salonCustomFilters = {
        ...state.salonCustomFilters,
        ...action.payload,
      };
    },
    removeSalonCustomFilter: (state, action) => {
      state.salonCustomFilters[action.payload.id] = null;
    },
    resetSalonCustomFilter: (state, action) => {
      state.salonCustomFilters = {};
    },
  },
});

export const {
  setSelectedSalon,
  resetBookingData,
  setSalonBookedData,
  setSalonAttributeFilter,
  removeSalonAttributeFilter,
  resetSalonAttributeFilter,
  setSalonCustomFilter,
  removeSalonCustomFilter,
  resetSalonCustomFilter,
} = salonSlice.actions;

export default salonSlice.reducer;
